import React, { Component }  from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HeaderComponent from "./components/header";
import FooterComponent from "./components/footer";
import Home from "./pages/home";
import Contact from "./pages/contact";

import Projects from "./pages/projects";
// import Campaigns from './pages/campaign';
import FAQ from './pages/faq';
import Categories from './pages/categories'
import calculationResult from './pages/calculationResult'
import calculationPage from './pages/calculationPage'
import SubContent from './pages/contents';

import './App.css';

class App extends Component {
  
  render() {
    return (
      <>
          <HeaderComponent />
          <main role="main"> 
            <Router>
              <Switch>
                <Route exact path="/" component={Home}/>
                <Route path="/mortgage-hakkinda" component={Contact}/>
                <Route path="/anlasmali-konut-projeleri" component={Projects}/>
                {/* <Route path="/kampanyalar" component={Campaigns}/> */}
                <Route path="/finansman-hesaplama" component={calculationPage}/>
                <Route path="/finansman-hesaplama-detay" component={calculationResult}/>
                <Route exact path="/mortgage" component={Categories}/>
                <Route exact path="/blog" component={Categories}/>
                <Route exact path="/konut-finansman-urunlerimiz" component={Categories}/>
                <Route exact path="/konut-satis-istatistikleri" component={Categories}/>
                <Route exact path="/ev-alim-rehberi" component={Categories}/>
                <Route exact path="/sigortacilik-islemleri" component={Categories}/>
                <Route path="/bize-ulasin" component={Contact}/>

                <Route path="/sss" component={FAQ}/>
                <Route path="/:contentId" component={SubContent}/>
              </Switch>
            </Router>
             
          </main>
          <FooterComponent/>
      </>
    );
  }
}

export default App;
